import CityPageTemplate from "../city-template/CityPageTemplate";
import { ellsworthConfig } from "./data";

export default function EllsworthPage() {
  return <CityPageTemplate config={ellsworthConfig} />;
}